<mat-toolbar class="header">
    <mat-toolbar-row class="mat-elevation-z4" fxLayout="row">
        <div fxFlex="90">
            <img id="menu-icon" class="image" src="../../assets/img/menu.png"
                (click)="toggleSidenav()">
        </div>
        <div fxFlex="5">
            <button *ngIf="showLogin" (click)="login()" class="button1">Login</button>
            <button *ngIf="!showLogin" (click)="logout()" class="button1">Logout</button>
        </div>
        <div fxFlex="5">
            <a fxLayoutAlign="center" href="https://ditect.eu/">
                <img src="../../assets/img/ditect-white.png" style="width: 75%; cursor: pointer; border-radius: 50%;">
            </a>
        </div>
    </mat-toolbar-row>
</mat-toolbar>